export const FLAG_GETTING_MANUAL_VOUCHER_SERVICE_TYPES = 'FLAG_GETTING_MANUAL_VOUCHER_SERVICE_TYPES';
export const GET_MANUAL_VOUCHER_SERVICE_TYPES = 'GET_MANUAL_VOUCHER_SERVICE_TYPES';
export const CLEAR_MANUAL_VOUCHER_SERVICE_TYPES = 'CLEAR_MANUAL_VOUCHER_SERVICE_TYPES';
